window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.digitalCertificateCheckBox = window.locales.am.digitalCertificateCheckBox || {};window.locales.am.digitalCertificateCheckBox = {...window.locales.am.digitalCertificateCheckBox, ...{
    "heading": "የሰርተፊኬት መፈተሻ",
    "content": "ስምዎ በሰርተፊኬትዎ ላይ እንደሚታየው ይታያል?",
    "buttonUpdateName": "ስም ያዘምኑ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.digitalCertificateCheckBox = window.locales.ar.digitalCertificateCheckBox || {};window.locales.ar.digitalCertificateCheckBox = {...window.locales.ar.digitalCertificateCheckBox, ...{
    "heading": "فحص الشهادة",
    "content": "هل يظهر اسمك بالطريقة التي تريدها على شهادتك؟",
    "buttonUpdateName": "تحديث الاسم"
}
};window.locales.en = window.locales.en || {};window.locales.en.digitalCertificateCheckBox = window.locales.en.digitalCertificateCheckBox || {};window.locales.en.digitalCertificateCheckBox = {...window.locales.en.digitalCertificateCheckBox, ...{
    "heading": "Certificate Check",
    "content": "Does your name appear the way you'd like it to be shown on your certificate?",
    "buttonUpdateName": "Update Name"
}
};window.locales.es = window.locales.es || {};window.locales.es.digitalCertificateCheckBox = window.locales.es.digitalCertificateCheckBox || {};window.locales.es.digitalCertificateCheckBox = {...window.locales.es.digitalCertificateCheckBox, ...{
    "heading": "Verificación de Certificado",
    "content": "¿Aparece su nombre de la manera que desea que se muestre en su certificado?",
    "buttonUpdateName": "Actualizar Nombre"
}
};window.locales.it = window.locales.it || {};window.locales.it.digitalCertificateCheckBox = window.locales.it.digitalCertificateCheckBox || {};window.locales.it.digitalCertificateCheckBox = {...window.locales.it.digitalCertificateCheckBox, ...{
    "heading": "Controllo Certificato",
    "content": "Il tuo nome appare nel modo in cui vorresti che fosse mostrato sul tuo certificato?",
    "buttonUpdateName": "Aggiorna Nome"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.digitalCertificateCheckBox = window.locales.zh.digitalCertificateCheckBox || {};window.locales.zh.digitalCertificateCheckBox = {...window.locales.zh.digitalCertificateCheckBox, ...{
    "heading": "证书检查",
    "content": "您的姓名是否按您希望在证书上显示的方式出现？",
    "buttonUpdateName": "更新姓名"
}
};